import { Box, Typography, useTheme } from "@mui/material";
import type { ChipOption } from "../../types";
import { OnboardingOtherInput } from "./OnboardingOtherInput";
import { OnboardingSelectionChip } from "./OnboardingSelectionChip";

interface OnboardingCategoryGroupProps {
  label: string;
  options: ChipOption[];
  selectedValues: string[];
  onToggle: (value: string) => void;
  otherText?: string;
  onOtherTextChange?: (value: string) => void;
  otherError?: boolean;
  onOtherErrorClear?: () => void;
}

export const OnboardingCategoryGroup = ({
  label,
  options,
  selectedValues,
  onToggle,
  otherText,
  onOtherTextChange,
  otherError,
  onOtherErrorClear,
}: OnboardingCategoryGroupProps): JSX.Element => {
  const theme = useTheme();
  const isOtherSelected = selectedValues.includes("other");
  const isNoneDisabled = selectedValues.some((v) => v !== "none");
  const hasNoneOption = options.some((o) => o.value === "none");

  return (
    <Box sx={{ marginBottom: "20px" }}>
      <Typography
        variant="caption-2"
        sx={{
          color: theme.palette.secondary["purple-tint"],
          marginBottom: "12px",
          display: "block",
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {options.map((option) => (
          <OnboardingSelectionChip
            key={option.value}
            label={option.label}
            isSelected={selectedValues.includes(option.value)}
            onClick={() => onToggle(option.value)}
            badge={option.badge}
            showCheck
            disabled={
              hasNoneOption && option.value === "none" && isNoneDisabled
            }
          />
        ))}
      </Box>
      {isOtherSelected && onOtherTextChange && (
        <Box sx={{ marginTop: "8px" }}>
          <OnboardingOtherInput
            value={otherText ?? ""}
            onChange={onOtherTextChange}
            error={otherError}
            onErrorClear={onOtherErrorClear}
          />
        </Box>
      )}
    </Box>
  );
};
